<template>
  <div>
    <KpiCards
      :orders="pedidosPrincipais"
      status-field="pedidoSituacao"
      :status-options="optionsSit"
      :selected-status="appliedFilters.pedidoSituacao || null"
      :status-loading="$store.getters['PTC_PedidosClient/getIsLoading']"
      :disabled="$store.getters['PTC_PedidosClient/getIsLoading']"
      :backorders-selected="somenteBackorders"
      :backorders-count="totalBackorders"
      :backorders-loading="backordersLoading"
      :backorders-error="backordersError"
      @backorders="handleBackordersFilter"
      @filter="handleKpiFilter"
      @retry-backorders="fetchBackordersCount(appliedFilters)"
    />
    <b-overlay :show="$store.getters['PTC_PedidosClient/getIsLoading']">

      <b-modal v-model="showModalNF" size="lg" title="Nota Fiscal" hide-footer modal-class="modal-pdf">
        <iframe :src="pdfUrlNF" width="100%" height="600px"></iframe>
      </b-modal>

      <b-modal v-model="showModal" size="lg" title="Relatório Pedido" hide-footer modal-class="modal-pdf">
        <div v-if="isLoadingPdf" class="text-center p-4">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2 text-muted">Gerando PDF...</p>
        </div>
        <iframe v-else :src="pdfUrl" width="100%" height="600px"></iframe>
      </b-modal>

      <b-card no-body class="mb-0">
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <b-form-select
                v-model="perPage"
                :options="pageOptions"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                v-b-toggle.pedidos-filtros-collapse
                variant="outline-primary"
                class="mr-1"
              >
                <feather-icon icon="FilterIcon" size="14" />
                <span class="ml-25">Filtros</span>
                <b-badge v-if="activeFiltersCount > 0" variant="light-primary" pill class="ml-50">
                  {{ activeFiltersCount }}
                </b-badge>
              </b-button>

              <b-button
                v-if="pedidos.length > 0"
                variant="outline-secondary"
                class="mr-1"
                :disabled="isExporting"
                @click="exportData"
              >
                <feather-icon icon="DownloadIcon" size="14" />
                <span class="ml-25">{{ isExporting ? 'Exportando…' : 'Exportar' }}</span>
              </b-button>

              <b-button
                variant="primary"
                @click="novoPedido"
              >
                <feather-icon icon="PlusIcon" size="14" />
                <span class="ml-25">Novo Pedido</span>
              </b-button>
            </b-col>
          </b-row>

          <b-collapse id="pedidos-filtros-collapse" class="mt-2">
            <b-card no-body class="border p-1 mb-0">
              <b-row>
                <b-col cols="12" md="4" lg="3" class="mb-1">
                  <label>Nº Pedido</label>
                  <b-form-input
                    v-model="items.nrPedido_PW"
                    placeholder="Pedido ou referência BO exata"
                    aria-describedby="pedido-bo-hint"
                  />
                  <small id="pedido-bo-hint" class="text-muted">A referência BO exata localiza o pedido principal.</small>
                </b-col>

                <b-col cols="12" md="4" lg="3" class="mb-1">
                  <label>Período De</label>
                  <b-form-input type="date" v-model="items.de" />
                </b-col>

                <b-col cols="12" md="4" lg="3" class="mb-1">
                  <label>Período Até</label>
                  <b-form-input type="date" v-model="items.ate" />
                </b-col>

                <b-col v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false" cols="12" md="4" lg="3" class="mb-1">
                  <label>Data Entrega</label>
                  <b-form-input type="date" v-model="items.dataEntrega" />
                </b-col>

                <!-- Perfil Cliente não vê o próprio código ERP/razão social (dados da base Macmillan). -->
                <b-col v-if="!isClienteAtivo" cols="12" md="4" lg="3" class="mb-1">
                  <label>Cliente ID ERP</label>
                  <b-form-input
                    v-model="items.codClienteERP"
                    placeholder="Código ERP"
                  />
                </b-col>

                <b-col v-if="!isClienteAtivo" cols="12" md="4" lg="3" class="mb-1">
                  <label>Razão Social</label>
                  <b-form-input
                    v-model="items.razaoSocialCliente"
                    placeholder="Nome do cliente"
                  />
                </b-col>

                <b-col cols="12" md="4" lg="3" class="mb-1">
                  <label>Tipo</label>
                  <b-form-select v-model="selected" :options="options" />
                </b-col>

              </b-row>

              <div class="d-flex justify-content-end mt-1">
                <b-button
                  variant="outline-secondary"
                  class="mr-1"
                  @click="limpar"
                >
                  <feather-icon icon="XIcon" size="14" />
                  <span class="ml-25">Limpar</span>
                </b-button>
                <b-button
                  variant="primary"
                  @click="filters('filter')"
                >
                  <feather-icon icon="SearchIcon" size="14" />
                  <span class="ml-25">Filtrar</span>
                </b-button>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <b-table
          ref="refPedidosListTable"
          class="position-relative"
          :items="pedidos"
          responsive
          show-empty
          hover
          primary-key="_listingKey"
          :tbody-tr-attr="pedidoRowAttrs"
          :fields="colunasVisiveis"
          :per-page="perPage"
          :current-page="currentPage"
          empty-text="Nenhum registro encontrado"
          @row-clicked="detalhesPedido"
        >
          <template #cell(nrPedido_PW)="data">
            {{ data.item._referenciaPrincipal }}
          </template>
          <template #cell(nrPedido_ERP)="data">
            {{ data.item.nrPedido_ERP || '-' }}
          </template>

          <template #cell(nomeTipoPedido)="data">
            {{ data.item.nomeTipoPedido || '-' }}
          </template>

          <template #cell(dataEmissao)="data">
            {{ safeDate(data.item.dataEmissao) }}
          </template>

          <template #cell(dataEntrega)="data">
            {{ safeDate(data.item.dataEntrega) }}
          </template>

          <template #cell(valorTotalPedido)="data">
            <span :title="complementoValorBo(data.item)">
              {{ data.item._isBackorder ? valorBoExibido(data.item) : formatCurrency(data.item.valorTotalPedido) }}
              <small v-if="motivoValorBo(data.item)" class="bo-price-reason text-muted">{{ motivoValorBo(data.item) }}</small>
            </span>
          </template>

          <template #cell(pedidoSituacao)="data">
            <b-badge :variant="resolveSituacaoVariant(data.item.pedidoSituacao)" pill>
              {{ data.item.pedidoSituacao }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="d-inline-flex align-items-center text-nowrap" @click.stop>
              <b-button
                variant="gradient-primary"
                class="btn-icon mr-50"
                size="sm"
                :title="data.item._isBackorder ? 'Ver atendimento desta BO' : 'Ver detalhes'"
                @click="detalhesPedido(data.item)"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>
              <b-button
                variant="gradient-info"
                class="btn-icon mr-50"
                size="sm"
                title="Imprimir"
                @click="exibirModalPdf(data.item)"
              >
                <feather-icon icon="PrinterIcon" />
              </b-button>
              <b-button
                variant="gradient-secondary"
                class="btn-icon"
                size="sm"
                title="Nota Fiscal"
                @click="goToNotaFiscal(data.item)"
              >
                <feather-icon icon="FileTextIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Mostrando {{ paginationStart }} até {{ paginationEnd }} de {{ pedidos.length }} registros
              </span>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="pedidos.length"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { valorBoExibido, complementoValorBo, motivoValorBo, pedidoListingRows, pedidoRowId, backorderMode, pedidoCategory } from '@/utils/pedidoListingRows';
import {
  VBTooltip,
  VBToggle,
  BButton,
  BFormSelect,
  BFormInput,
  BCard,
  BRow,
  BCol,
  BTable,
  BPagination,
  BOverlay,
  BBadge,
  BCollapse,
  BModal,
  BSpinner,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import PTC_PedidosService from '@/services/PTC/PTC_Pedidos.service';
import { isPerfilClienteAtivo } from '@/libs/perfilCliente';
import { mapGetters } from 'vuex';
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import FilesService from '@/services/Operacoes/files.service';
import KpiCards from '@/views/app/operacoes/pedidosVendas/components/KpiCards.vue';

const ptc_pedidosService = new PTC_PedidosService();
const filesService = new FilesService();

export default {
  components: {
    KpiCards,
    BFormSelect,
    BFormInput,
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BOverlay,
    BBadge,
    BCollapse,
    BModal,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    Ripple,
  },
  data() {
    return {
      dataDash: this.$route.params.dataDash || null,
      situacaoPedido: this.$route.params.situacaoPedido || null,
      items: {
        nrPedido_PW: '',
        de: '',
        ate: '',
        dataEntrega: '',
        codClienteERP: '',
        razaoSocialCliente: '',
      },
      selected: null,
      options: [
        { value: null, text: '-- Todos --', disabled: false },
      ],
      selectedSit: null,
      appliedFilters: {},
      optionsSit: [
        { value: null, text: '-- Todos --', disabled: false },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      showModal: false,
      showModalNF: false,
      pdfUrl: '',
      pdfUrlNF: '',
      isLoadingPdf: false,
      isExporting: false,
      tableColumns: [
        { key: 'nrPedido_PW', label: 'Pré-pedido', class: 'text-center text-nowrap', thStyle: { width: '1%' } },
        { key: 'nrPedido_ERP', label: 'Pedido ERP', class: 'text-center' },
        { key: 'codClienteERP', label: 'Cliente' },
        { key: 'razaoSocialCliente', label: 'Razão Social' },
        { key: 'nomeTipoPedido', label: 'Tipo' },
        { key: 'dataEmissao', label: 'Emissão', class: 'text-center' },
        { key: 'dataEntrega', label: 'Prev. Fatur.', class: 'text-center' },
        { key: 'valorTotalPedido', label: 'Valor Total', class: 'text-right' },
        { key: 'pedidoSituacao', label: 'Situação', class: 'text-center' },
        { key: 'actions', label: 'Ações', class: 'text-center' },
      ],
    };
  },
  watch: {
    'items.de': function (newVal) {
      this.updateDataDash();
    },
    'items.ate': function (newVal) {
      this.updateDataDash();
    },
    perPage(newVal) {
      this.currentPage = 1;
    },
    pedidos: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.populateTypeOptions();
          this.populateSitOptions();
        }
        const maxPage = Math.ceil((newVal?.length || 0) / this.perPage) || 1;
        if (this.currentPage > maxPage) {
          this.currentPage = maxPage;
        }
      },
      deep: true,
    },
  },
  methods: {
    valorBoExibido,
    complementoValorBo,
    motivoValorBo,
    pedidoRowAttrs(row) {
      return row ? { id: pedidoRowId(row), tabindex: '-1' } : {};
    },
    async fetchBackordersCount(query) {
      try {
        await ptc_pedidosService.contarBackorders(query);
      } catch (_) {
        // The store exposes the error on the KPI, never a fake page-level count.
      }
    },
    async loadPedidos(query = {}) {
      const requestedFilters = { ...query };
      this.currentPage = 1;
      await Promise.all([
        ptc_pedidosService.retornaPedidos(requestedFilters),
        this.fetchBackordersCount(requestedFilters),
      ]);
      // A rejected list must not re-present the previous parents in BO mode.
      this.appliedFilters = requestedFilters;
    },
    async handleBackordersFilter() {
      if (this.$store.getters['PTC_PedidosClient/getIsLoading']) return;
      const query = { ...this.appliedFilters };
      if (this.somenteBackorders) delete query.somenteBackorders;
      else query.somenteBackorders = true;
      delete query.pedidoSituacao;
      this.selectedSit = null;
      await this.loadPedidos(query);
    },
    async handleKpiFilter(status) {
      if (this.$store.getters['PTC_PedidosClient/getIsLoading']) return;
      // Reuse the single selectedSit/pedidoSituacao contract. Only change the
      // applied situation; pending drawer fields must not replace other filters.
      const query = { ...this.appliedFilters };
      delete query.somenteBackorders;
      delete query.pedidoSituacao;
      this.selectedSit = status;
      if (status !== null) query.pedidoSituacao = status;
      await this.loadPedidos(query);
    },
    safeDate(value) {
      if (!value) return '-';
      const s = String(value).trim();
      if (s.toLowerCase().includes('invalid')) return '-';

      // A API do PTC já devolve datas como DD/MM/YYYY. Preserve esse formato
      // após validar dia/mês/ano explicitamente — new Date('31/12/2025') não é
      // portável e pode virar Invalid Date ou inverter dia e mês.
      const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (br) {
        const dia = Number(br[1]);
        const mes = Number(br[2]);
        const ano = Number(br[3]);
        const validacao = new Date(Date.UTC(ano, mes - 1, dia));
        const valida = validacao.getUTCFullYear() === ano
          && validacao.getUTCMonth() === mes - 1
          && validacao.getUTCDate() === dia;
        return valida ? s : '-';
      }

      const d = new Date(value);
      if (isNaN(d.getTime())) return '-';
      return d.toLocaleDateString('pt-BR');
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '-';
      // Aceita número, string numérica ("1234.56") ou string já formatada ("R$ 1.234,56")
      if (typeof value === 'string' && value.trim().startsWith('R$')) return value;
      const num = typeof value === 'string' ? parseFloat(value) : value;
      if (Number.isNaN(num)) return '-';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(num);
    },
    resolveSituacaoVariant(situacao) {
      const normalized = (situacao || '').toLowerCase().trim();
      if (normalized.includes('aprovado') || normalized.includes('concluido') || normalized.includes('concluído') || normalized.includes('faturado')) {
        return 'light-success';
      }
      if (normalized.includes('pendente') || normalized.includes('aguardando') || normalized.includes('análise') || normalized.includes('analise')) {
        return 'light-warning';
      }
      if (normalized.includes('cancelado') || normalized.includes('recusado') || normalized.includes('rejeitado') || normalized.includes('bloqueado')) {
        return 'light-danger';
      }
      if (normalized.includes('rascunho') || normalized.includes('draft')) {
        return 'light-secondary';
      }
      if (normalized.includes('processando') || normalized.includes('em andamento') || normalized.includes('aberto')) {
        return 'light-primary';
      }
      return 'light-secondary';
    },
    updateDataDash() {
      this.dataDash = {
        de: this.items.de,
        ate: this.items.ate,
      };
    },
    novoPedido() {
      this.$router.push({ name: 'pedidos-vendas-create' });
    },
    async exportData() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const filtrosExportacao = { ...this.appliedFilters };
        if (this.isClienteAtivo) {
          delete filtrosExportacao.codClienteERP;
          delete filtrosExportacao.razaoSocialCliente;
        }
        // Server XLSX mapping owns the same latest-BO presentation and exports
        // all authorized matches, not the capped/paginated list response.
        const blob = await ptc_pedidosService.exportarPedidos(filtrosExportacao);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        const hoje = new Date().toISOString().slice(0, 10);
        a.href = url;
        a.download = `pedidos_${hoje}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('[Pedidos] erro ao exportar', e);
        this.$bvToast.toast('Não foi possível exportar os pedidos.', { title: 'Exportar', variant: 'danger', solid: true });
      } finally {
        this.isExporting = false;
      }
    },
    goToNotaFiscal(pedido) {
      const pedidoId = String(pedido?.nrPedido_PW ?? '');
      if (!/^-?\d+$/.test(pedidoId) || !Number.isSafeInteger(Number(pedidoId)) || Number(pedidoId) === 0) {
        this.$bvToast.toast('Não foi possível identificar o pedido para consultar suas notas fiscais.', {
          title: 'Nota Fiscal',
          variant: 'warning',
          solid: true,
        });
        return;
      }

      this.$router.push({
        name: 'notaFiscal',
        params: { tenantSlug: this.$route.params.tenantSlug },
        query: { pedidoid: pedidoId, etapaPedido: pedido._etapaFiscal || 'original' },
      });
    },
    async exibirModalPdf(data) {
      try {
        this.showModal = true;
        this.isLoadingPdf = true;

        await filesService.indexFiles(data.nrPedido_PW, data._isBackorder ? data.nrPedido_ERP : undefined);
        this.pdfUrl = this.$store.state.filesStore.generatedLabelUrl;
      } catch (error) {
        console.error('Erro ao gerar o PDF:', error);
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: 'Não foi possível gerar o PDF. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.showModal = false;
      } finally {
        this.isLoadingPdf = false;
      }
    },
    async getPedidos() {
      await this.loadPedidos();
      this.populateTypeOptions();
      this.populateSitOptions();
    },
    async baixarNotaFiscal(data) {
      try {
        const url = `ptc/danf?EstabelecimentoId=${data.codEstabelecimento}&NotaFiscalNumero=0394761&notafiscalserie=${data.NotaFiscal[0].numeroSerie}`;
        this.$store.commit('PTC_PedidosClient/SET_IS_LOADING', true);
        const response = await axios.get(url);
        this.pdfUrlNF = response.data;
        this.showModalNF = true;
        this.$store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: 'Não foi possível gerar a Nota Fiscal.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.$store.commit('PTC_PedidosClient/SET_IS_LOADING', false);
      }
    },
    async detalhesPedido(pedido) {
      await this.$router.push({
        name: 'pedido_detalhe',
        params: {
          tenantSlug: this.$route.params.tenantSlug,
          id: pedido.nrPedido_PW,
        },
        ...(pedido._isBackorder ? { query: { bo: pedido.nrPedido_ERP } } : {}),
      });
    },
    async filters() {
      const query = {};

      if (this.items.nrPedido_PW) {
        query.nrPedido_PW = this.items.nrPedido_PW;
      }

      if (this.items.codClienteERP) {
        query.codClienteERP = this.items.codClienteERP;
      }

      if (this.items.razaoSocialCliente) {
        query.razaoSocialCliente = this.items.razaoSocialCliente;
      }

      if (this.selected !== null) {
        query.nomeTipoPedido = this.selected;
      }

      const dePreenchido = this.items.de !== null && this.items.de !== '' && this.items.de !== undefined;
      const atePreenchido = this.items.ate !== null && this.items.ate !== '' && this.items.ate !== undefined;

      if ((!dePreenchido && !atePreenchido) || (dePreenchido && atePreenchido)) {
        if (dePreenchido && atePreenchido) {
          query.DataEmissaoDe = this.items.de;
          query.DataEmissaoAte = this.items.ate;
        }
      } else if (dePreenchido) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Atenção',
            text: 'Preencha o campo "Até" quando "De" estiver preenchido.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      } else if (atePreenchido) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Atenção',
            text: 'Preencha o campo "De" quando "Até" estiver preenchido.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (this.items.dataEntrega && this.$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false) {
        query.dataEntrega = this.items.dataEntrega;
      }

      if (this.selectedSit !== null) {
        if (String(this.selectedSit).trim().toUpperCase() === 'BACK ORDER') query.somenteBackorders = true;
        else query.pedidoSituacao = this.selectedSit;
      } else if (this.somenteBackorders) {
        query.somenteBackorders = true;
      }

      await this.loadPedidos(query);

      this.$root.$emit('bv::toggle::collapse', 'pedidos-filtros-collapse');
    },
    populateTypeOptions() {
      if (this.pedidos && this.pedidos.length > 0) {
        const uniqueTypes = [...new Set(this.pedidos.map((pedido) => pedido.nomeTipoPedido))];
        this.options = [{ value: null, text: '-- Todos --', disabled: false }];
        uniqueTypes.forEach(type => {
          if (type) {
            this.options.push({ value: type, text: type });
          }
        });
      }
    },
    populateSitOptions() {
      if (this.pedidosPrincipais && this.pedidosPrincipais.length > 0) {
        const uniqueSit = [...new Set([
          ...this.optionsSit.map(option => option.value),
          ...this.pedidosPrincipais.map(pedido => pedidoCategory(pedido) === 'BACK ORDER'
            ? 'BACK ORDER' : pedido.pedidoSituacao),
        ])];
        this.optionsSit = [{ value: null, text: '-- Todos --', disabled: false }];
        uniqueSit.forEach(type => {
          if (type) {
            this.optionsSit.push({ value: type, text: type });
          }
        });
      }
    },
    async limpar() {
      this.items = {
        nrPedido_PW: '',
        de: '',
        ate: '',
        dataEntrega: '',
        codClienteERP: '',
        razaoSocialCliente: '',
      };
      this.dataDash = null;
      this.selected = null;
      this.selectedSit = null;
      await this.loadPedidos();
    },
  },
  async mounted() {
    let query = {};

    if (this.dataDash !== null && this.dataDash !== '') {
      this.items.de = this.dataDash.dataInicial;
      this.items.ate = this.dataDash.dataFinal;
      query = {
        DataEmissaoDe: this.dataDash.dataInicial,
        DataEmissaoAte: this.dataDash.dataFinal,
      };
    }

    if (this.situacaoPedido) {
      if (String(this.situacaoPedido).trim().toUpperCase() === 'BACK ORDER') {
        query.somenteBackorders = true;
        this.selectedSit = null;
      } else {
        query.pedidoSituacao = this.situacaoPedido;
        this.selectedSit = this.situacaoPedido;
      }
    }

    await this.loadPedidos(query);

    this.populateTypeOptions();
    this.populateSitOptions();
  },
  computed: {
    ...mapGetters({
      pedidosPrincipais: 'PTC_PedidosClient/getPedidos',
      totalBackorders: 'PTC_PedidosClient/getTotalBackorders',
      backordersLoading: 'PTC_PedidosClient/getBackordersLoading',
      backordersError: 'PTC_PedidosClient/getBackordersError',
    }),
    somenteBackorders() {
      return backorderMode(this.appliedFilters.somenteBackorders);
    },
    pedidos() {
      return pedidoListingRows(this.pedidosPrincipais, 'portal', this.somenteBackorders, this.appliedFilters.pedidoSituacao);
    },
    // Perfil Cliente não vê o próprio código ERP nem a razão social da base.
    isClienteAtivo() {
      return isPerfilClienteAtivo();
    },
    colunasVisiveis() {
      return this.tableColumns.filter((c) =>
        (c.key !== 'dataEntrega' || this.$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false)
        && (!this.isClienteAtivo || !['codClienteERP', 'razaoSocialCliente'].includes(c.key)));
    },
    paginationStart() {
      if (!this.pedidos.length) return 0;
      return ((this.currentPage - 1) * this.perPage) + 1;
    },
    paginationEnd() {
      const end = this.currentPage * this.perPage;
      return end > this.pedidos.length ? this.pedidos.length : end;
    },
    activeFiltersCount() {
      let count = 0;
      if (this.items.nrPedido_PW) count++;
      if (this.items.de) count++;
      if (this.items.ate) count++;
      if (this.items.dataEntrega && this.$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false) count++;
      if (this.items.codClienteERP) count++;
      if (this.items.razaoSocialCliente) count++;
      if (this.selected) count++;
      if (this.selectedSit) count++;
      if (this.somenteBackorders) count++;
      return count;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.bo-price-reason {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
